import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ViewRequestOptions } from '../../shared/resolvers/view-requests.resolver';
import { CurrentUser } from '../../shared/services/current-user.service';

@Component({
  selector: 'app-request-list-page',
  templateUrl: './request-list-page.component.html'
})
export class RequestListPageComponent implements OnInit {

  public requestOptions: ViewRequestOptions;
  public currentUser: CurrentUser;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.requestOptions =  this.route.snapshot.data['requestOptions'] as ViewRequestOptions;
    this.currentUser = this.route.snapshot.data['currentUser'] as CurrentUser;
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-list-page/request-list-page.component.ts